import { hermesConfig } from '../../../edge/request/hermes.config';
import { hermesCourierService } from '../../../edge/request/services/hermes.courier.service';
import { UnifiedDestinationsResponse } from '../interfaces/unifiedDestination';

// Combined destinations across both engines (standard + edge), aggregated by the
// h20 config service. Lives with the destination APIs (not the pipelines-list
// feature) since it is a destinations concern; the unified pipelines listing and
// global search consume it to power the destination filter.
// Resolves to GET /h20/api/config/v2.0/unified/destinations.
const UNIFIED_DESTINATIONS_URL = hermesConfig.getUnifiedDestinationsURL();

export const UnifiedDestinationsAPI = {
  /** Combined destinations from both engines — powers the destination filter. */
  async getDestinations(): Promise<UnifiedDestinationsResponse> {
    const res = await hermesCourierService.get<UnifiedDestinationsResponse>(
      UNIFIED_DESTINATIONS_URL
    );

    // Reject the backend error envelope ({ error_message, api_code }) arriving
    // as a resolved body so consumers land in their error/empty state instead
    // of crashing on a missing `data` array.
    if (!res || !Array.isArray(res.data)) {
      throw new Error(
        (res as unknown as { error_message?: string })?.error_message ||
          'Failed to fetch Destinations'
      );
    }

    return res;
  }
};
